import ExtensionCommunicationService from '../extension-communication-service';
import StorageService from '../storage-service';
import ClientAlertsService from './client-alerts-service';
import ALERT_STATUSES from './alert-statuses.json';
import InboxService from '@/components/Inbox/inbox-service';
const stg = StorageService.getStorage();

const CLIENT_ALERTS_KEY = 'client_alerts';

// private
let visibilityChangeListener = null;
const setVisibilityChangeListener = (value) => {
	const oldVisibilityChangeListener = visibilityChangeListener;
	visibilityChangeListener = value;
	if (oldVisibilityChangeListener) {
		document.removeEventListener('visibilitychange', oldVisibilityChangeListener);
	}
};
const clearVisibilityChangeListener = () => {
	if (visibilityChangeListener) {
		document.removeEventListener('visibilitychange', visibilityChangeListener);
		setVisibilityChangeListener(null);
	}
};
const setClientAlertsInStorage = (alerts) => stg.setItem(CLIENT_ALERTS_KEY, alerts);
const getClientAlertsFromStorage = () => stg.getItem(CLIENT_ALERTS_KEY) || [];
const getDefaultAlerts = async (callback) => {
	const isExtensionInstalled = await ExtensionCommunicationService.isInstalled();
	// const doesExtensionHasInjectionPermissions = isExtensionInstalled && (await ExtensionCommunicationService.checkPermissionForAllUrls());
	const alerts = [
		ClientAlertsService.getInstallExtensionAlert(isExtensionInstalled),
		// ClientAlertsService.getAllowExtensionInjectionAlert(isExtensionInstalled, doesExtensionHasInjectionPermissions),
	];
	if (!isExtensionInstalled) {
		setVisibilityChangeListener(() => {
			if (!document.hidden) {
				clearVisibilityChangeListener();
				callback();
			}
		});
		document.addEventListener('visibilitychange', visibilityChangeListener);
	}
	return alerts;
};

const updateClientAlertInArray = (alerts, alert, preventReplace = false) => {
	const oldAlertIndex = alerts.findIndex((a) => a.id === alert.id);
	const alertExists = oldAlertIndex !== -1;
	const oldAlert = alerts[oldAlertIndex];
	let newAlert = alert;
	// replace alert if exists
	if (alertExists) {
		if (!preventReplace) {
			newAlert = { ...oldAlert, ...alert };
			alerts[oldAlertIndex] = newAlert;
		}
	} else {
		alerts.push(newAlert);
	}
	return newAlert;
};

const updateClientAlertInStorage = (alert) => {
	const alerts = getClientAlertsFromStorage();
	const newAlert = updateClientAlertInArray(alerts, alert);
	setClientAlertsInStorage(alerts);
	return newAlert;
};

// public
const getClientAlerts = async (callback) => {
	const activeDefaultAlerts = await getDefaultAlerts(callback);
	const alertsInStorage = getClientAlertsFromStorage() || [];
	const alerts = activeDefaultAlerts;
	alertsInStorage.forEach((ais) => {
		let preventReplace = true;
		// user actively might marked alert as archived on purpose, revert this state only if status has changed
		if (ais.after_user_interaction) {
			const newAlert = alerts.find((a) => a.id === ais.id);
			preventReplace = ais.status !== newAlert.status;
		}
		updateClientAlertInArray(alerts, ais, preventReplace);
	});
	setClientAlertsInStorage(alerts);
	return alerts;
};
const isClientAlert = (alert) => alert.id < 0;

const updateClientAlert = (alert) => {
	alert.after_user_interaction = true;
	const newAlert = updateClientAlertInStorage(alert);
	return newAlert;
};

const isCompleted = (alert) => alert.status === ALERT_STATUSES.COMPLETED;
const isAlertRelatedToInbox = ({ alert, inboxId, isArchived }) =>
	alert.archived === isArchived && InboxService.isAlertRelevantToInbox({ alert, inboxId });

const AlertService = {
	isCompleted,
	isClientAlert,
	getClientAlerts,
	updateClientAlert,
	isAlertRelatedToInbox,
};

export default AlertService;
